import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInYears,
  format,
} from 'date-fns';

export function timeElapsed(date: Date) {
  const now = Date.now();
  const minutes = differenceInMinutes(now, date);
  const hours = differenceInHours(now, date);
  const days = differenceInDays(now, date);
  const years = differenceInYears(now, date);
  const time = format(date, 'HH:mm:ss');
  const dateWithTime = format(date, 'MM/dd/yyyy HH:mm:ss');

  let result = `Now @ ${time}`;
  if (minutes > 0 && hours === 0) {
    result = `${minutes}m ago @ ${time}`;
  } else if (hours > 0 && days === 0) {
    result = `${hours}h ago @ ${time}`;
  } else if (days > 0 && years === 0) {
    result = `${days}d ago @ ${dateWithTime}`;
  } else if (years > 0) {
    result = `${years}y ago @ ${dateWithTime}`;
  }

  return result;
}

export function minutesToSeconds(minutes: number): number {
  return minutes * 60;
}
export function secondsToMinutes(seconds: number): number {
  return seconds / 60;
}

export function minutesToTimeElapsed(totalMinutes: number, displayLevels?: number): string {
  return secondsToTimeElapsed(minutesToSeconds(totalMinutes), displayLevels, true);
}

export function secondsToTimeElapsed(
  totalSeconds: number,
  displayLevels?: number,
  ignoreSeconds: boolean = false,
): string {
  displayLevels = displayLevels == null || displayLevels <= 0 ? undefined : displayLevels;
  let seconds = Math.abs(totalSeconds);
  let minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  let hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  const days = Math.floor(hours / 24);
  hours -= days * 24;

  const parts = [
    days < 1 ? null : `${days}d`,
    days < 1 && hours < 1 ? null : `${hours}h`,
    !ignoreSeconds && hours < 1 && minutes < 1 ? null : `${minutes}m`,
    ignoreSeconds === true ? null : `${seconds}s`,
  ].filter((p) => p != null);

  const time = parts.slice(0, displayLevels).join(' ');
  return totalSeconds < 0 ? `-${time}` : time;
}

export function minutesToTimeString(totalMinute: number): string {
  let minutes = Math.abs(totalMinute);
  const hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  return `${('00' + hours).slice(-2)}:${('00' + minutes).slice(-2)}`;
}

export function getMinutesOfDay(date: Date) {
  return date.getHours() * 60 + date.getMinutes();
}
